import { User } from 'generated/graphql';

import { Box } from 'reflexbox';
import styled from 'styled-components';
import EvaluationAnswerLine from './EvaluationAnswerLine';

type CardVariant = 'default' | 'empty' | 'irrelevant';

const Card = styled(Box)<{ $variant: CardVariant }>`
	border-radius: 4px;
	padding: 12px;
	flex-grow: 1;
	background: ${(props) =>
		props.$variant === 'empty' || props.$variant === 'irrelevant'
			? props.theme.colors.lightBlueLight
			: props.theme.colors.white};
	opacity: ${(props) => (props.$variant === 'irrelevant' ? 0.5 : 1)};
	border: 1px solid ${(props) => props.theme.colors.lightBlue};
	box-shadow:
		0px 1px 2px rgba(0, 0, 0, 0.1),
		0px 8px 16px rgba(0, 0, 0, 0.1);
`;

export default function EvaluationAnswerCard({
	children,
	user,
	side,
	withAvatar = false,
	variant = 'default',
}: {
	children: React.ReactNode;
	side: 'left' | 'right';
	withAvatar?: boolean;
	user: User;
	variant?: CardVariant;
}) {
	return (
		<EvaluationAnswerLine user={user} side={side} withAvatar={withAvatar}>
			<Card $variant={variant}>{children}</Card>
		</EvaluationAnswerLine>
	);
}
